import request from '@/utils/request'
import { AxiosResult } from '@/typings/common'
import { FollowRuleSettingInfoDataParams, FollowRuleSettingUpdateParams } from '@/typings/api/overseasSales'

/**
 * ************************************** 首页 **************************************
 */
// 查询规则设置
export function infoData(data?: FollowRuleSettingInfoDataParams) {
  return request.post<AxiosResult>('/base/api/bizConfig/rule/info', data)
}
// 修改规则设置
export function updateData(data?: FollowRuleSettingUpdateParams) {
  return request.post<AxiosResult>('/base/api/bizConfig/rule/update', data)
}
